export const state = () => ({
  menuInitialRecommendationList: [],
});
